export default __webpack_public_path__ + "static/media/badge.c53a633e.png";